import react from "react";
import images from "../../../constant/images";
import { useTranslation } from "react-i18next";

export const Mission = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div
    id="Mission"
      style={{
        backgroundImage: `url(${images.mission})`,
        height: "30vh", // Adjusted for smaller screens
        backgroundRepeat: "no-repeat",
        marginTop: "5rem",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="text-center text-white flex flex-col justify-center h-full gap-4 px-4 sm:px-0">
        <div>
          <h1 className="text-2xl sm:text-3xl lg:text-4xl befor karla-font leading-relaxed tracking-wide">
            {t("aboutUs_content.mission")}
          </h1>
          <style>
            {`
          .befor {
            position: relative;
          }
          .befor::before {
            content: ' ';
            position: absolute;
            width: 20%; /* Adjusted for smaller screens */
            height: 1px;
            bottom: -10px; /* Adjusted for smaller screens */
            left: 40%; /* Adjusted for smaller screens */
            background-color: white;
          }

          @media (min-width: 640px) {
            .befor::before {
              width: 10%; /* Adjusted for medium screens */
              left: 45%; /* Adjusted for medium screens */
            }
          }

          @media (min-width: 1024px) {
            .befor::before {
              width: 6%; /* Adjusted for large screens */
              left: 47%; /* Adjusted for large screens */
              bottom: -12%; /* Adjusted for large screens */
            }
          }
        `}
          </style>
        </div>
        <p className="w-full sm:w-[80%] md:w-[60%] lg:w-[49vw] text-center mx-auto karla-font leading-relaxed tracking-wide text-sm sm:text-base">
          {t("aboutUs_content.mission_content")}
        </p>
      </div>
    </div>
  );
};
